import { createRequestTypes } from 'common/websocket-redux';

export const EMPLOYEE_DETAILS_INIT = createRequestTypes(
  'hr/employee-details/EMPLOYEE_DETAILS_INIT',
);
